/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Box } from '@mui/material';
import { useRecoilState } from 'recoil';
import Select from 'components/select';
import { sspSubmitOrder } from 'pages/provisioning/store/day2-operation';
import ProvisioningStyles from 'pages/provisioning/day2-operation/style';

const DiskSize = () => {
    const [isTouched, setIsTouched] = React.useState(false);
    const [order, setOrder] = useRecoilState(sspSubmitOrder);
    const [options, setOptions] = React.useState([]);
    const setDiskSize = (diskSizeInGB, diskSizeInGBDetail) => {
        setOrder({ ...order, diskSizeInGB, diskSizeInGBDetail });
    };
    const seldValueExistsInOptions = (diskSizeInGBValue) => options.find((option) => diskSizeInGBValue === option?.value);
    const handleOnSelectChange = (selected) => {
        if (seldValueExistsInOptions(selected?.value)) {
            setDiskSize(selected?.value, selected?.data);
        }
    };
    React.useEffect(() => {
        setOptions(['16', '32', '64', '120', '256', '512', '1024']?.map((data) => ({ label: data, value: data })));
    }, []);
    React.useEffect(() => {
        if (!order?.diskSizeInGB && order?.isTouched) setIsTouched(true);
    }, [order?.diskSizeInGB, order?.isTouched]);

    return (
        <Box sx={ProvisioningStyles.box}>
            <Select
                key="diskSizeInGB"
                label="Disk Size in GB *"
                value={order?.diskSizeInGB || null}
                options={options}
                handleOnSelect={(value) => handleOnSelectChange(value)}
                isRequired={isTouched}
            />
        </Box>
    );
};

export default React.memo(DiskSize);
